import { push } from 'react-router-redux';
import * as travelExpenseActions from '../../redux/modules/travelExpense';
import * as holidaysActions from '../../redux/modules/holidays';


const mapStateToProps = state => ({
  user: state.auth.user,
  language: state.auth.language,
  travelExpense: state.travelExpense,
  clearInput: state.travelExpense.clear,
  holidays: state.holidays

});

const mapDispatchToProps = {
  ...travelExpenseActions,
  ...holidaysActions,
  push
};

export default [mapStateToProps, mapDispatchToProps];



// WEBPACK FOOTER //
// ./src/containers/travel-expense/index.js